<template>
	<div class="footer-nav">
		<div class="nav-wrap">
			<div class="item" :class="{'item-cur': hov == index}" v-for="(item, index) in menu" :key='index'>
				<a href="javascript:;" @click="handlerLink" :data-index='index'>
					<img class="ico" :src="hov == index ? item.icon_hov : item.icon" />
					<div class="txt">{{item.name}}</div>
				</a>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name: 'FooterBar',
		components: {
			
		},
		props: {
			menu: {
				type: Array,
				default: () => []
			},
			hov: {
				type: Number,
				default: 0
			}
		},
		data() {
			return {
				
			}
		},
		methods: {
			handlerLink: function(e){
				let eIndex = parseInt(e.currentTarget.dataset.index)
				this.$router.push({
					path: `/${this.menu[eIndex].link}`
				})
			}
		},
		mounted: function(){
			
		}
	}
</script>

<style scoped>
.footer-nav{ position: fixed; bottom: 0; left: 0; right: 0; height: 1rem; background-color: #fff; z-index: 777; box-shadow: 0 0 0.1rem rgba(0, 0, 0, .1);}
.footer-nav>.nav-wrap{ display: flex; justify-content: space-around; align-items: center; width: 100%; height: 1rem;}
.footer-nav>.nav-wrap>.item{ flex: 1; -ms-flex: 0 0 33.33%; flex: 0 0 33.33%; max-width: 33.33%; box-sizing: border-box;}
.footer-nav>.nav-wrap>.item>a{ display: flex; justify-content: center; align-items: center; flex-direction: column; height: 1rem; text-decoration: none;}
.footer-nav>.nav-wrap>.item>a>.ico{ width: 0.48rem; height: 0.48rem; background-position: 50% 50% !important; background-size: cover !important;}
.footer-nav>.nav-wrap>.item>a>.txt{ font-size: 0.26rem; height: 0.32rem; line-height: 0.32rem; color: #d3d1d1;}
.footer-nav>.nav-wrap>.item-cur>a>.txt{ color: #3f58fd;}
</style>